export const campaignConstants = {
    CAMPAIGN_GET_LATEST_CAMPAIGN_REQUEST:
        "CAMPAIGN_GET_LATEST_CAMPAIGN_REQUEST",
    CAMPAIGN_GET_LATEST_CAMPAIGN_COMPLETE:
        "CAMPAIGN_GET_LATEST_CAMPAIGN_COMPLETE",

    GET_HOME_CAROUSEL_CAMPAIGN_REQUEST: "GET_HOME_CAROUSEL_CAMPAIGN_REQUEST",
    GET_HOME_CAROUSEL_CAMPAIGN_COMPLETE: "GET_HOME_CAROUSEL_CAMPAIGN_COMPLETE",

    GET_HOME_BEST_VOUCHER_DEALS_TODAY_REQUEST:
        "GET_HOME_BEST_VOUCHER_DEALS_TODAY_REQUEST",
    GET_HOME_BEST_VOUCHER_DEALS_TODAY_COMPLETE:
        "GET_HOME_BEST_VOUCHER_DEALS_TODAY_COMPLETE",

    GET_HOME_TRENDING_VOUCHER_REQUEST: "GET_HOME_TRENDING_VOUCHER_REQUEST",
    GET_HOME_TRENDING_VOUCHER_COMPLETE: "GET_HOME_TRENDING_VOUCHER_COMPLETE",

    GET_FEATURED_CAMPAIGN_BANNERS_REQUEST:
        "GET_FEATURED_CAMPAIGN_BANNERS_REQUEST",
    GET_FEATURED_CAMPAIGN_BANNERS_COMPLETE:
        "GET_FEATURED_CAMPAIGN_BANNERS_COMPLETE",

    GET_CAMPAIGN_DETAILS_REQUEST: "GET_CAMPAIGN_DETAILS_REQUEST",
    GET_CAMPAIGN_DETAILS_COMPLETE: "GET_CAMPAIGN_DETAILS_COMPLETE",

    CAMPAIGN_SPINWIN_TOKEN_VALIDATION_REQUEST:
        "CAMPAIGN_SPINWIN_TOKEN_VALIDATION_REQUEST",
    CAMPAIGN_SPINWIN_TOKEN_VALIDATION_COMPLETE:
        "CAMPAIGN_SPINWIN_TOKEN_VALIDATION_COMPLETE",

    CAMPAIGN_SPINWIN_TOKEN_VALIDATION_ERROR:
        "CAMPAIGN_SPINWIN_TOKEN_VALIDATION_ERROR",

    CAMPAIGN_LIQUID_GOLD_SCRATCH_CODE_VALIDATION_REQUEST:
        "CAMPAIGN_LIQUID_GOLD_SCRATCH_CODE_VALIDATION_REQUEST",
    CAMPAIGN_LIQUID_GOLD_SCRATCH_CODE_VALIDATION_COMPLETE:
        "CAMPAIGN_LIQUID_GOLD_SCRATCH_CODE_VALIDATION_COMPLETE",
    CAMPAIGN_LIQUID_GOLD_SCRATCH_CODE_VALIDATION_ERROR:
        "CAMPAIGN_LIQUID_GOLD_SCRATCH_CODE_VALIDATION_ERROR",
    CAMPAIGN_LIQUID_GOLD_SCRATCH_CODE_VALIDATION_RESET:
        "CAMPAIGN_LIQUID_GOLD_SCRATCH_CODE_VALIDATION_RESET",

    CAMPAIGN_SPINWIN_GET_DATA_REQUEST: "CAMPAIGN_SPINWIN_GET_DATA_REQUEST",
    CAMPAIGN_SPINWIN_GET_DATA_COMPLETE: "CAMPAIGN_SPINWIN_GET_DATA_COMPLETE",

    CAMPAIGN_SPINWIN_GET_INITIAL_DATA_REQUEST:
        "CAMPAIGN_SPINWIN_GET_INITIAL_DATA_REQUEST",
    CAMPAIGN_SPINWIN_GET_INITIAL_DATA_COMPLETE:
        "CAMPAIGN_SPINWIN_GET_INITIAL_DATA_COMPLETE",

    JOING_INCENTIVE_DATA_REQUEST: "JOING_INCENTIVE_DATA_REQUEST",
    JOING_INCENTIVE_DATA_COMPLETE: "JOING_INCENTIVE_DATA_COMPLETE",

    SPINWHEEL_TOKEN_RESET: "SPINWHEEL_TOKEN_RESET",

    CAMPAIGN_HOME_BANNERS_REQUEST: "CAMPAIGN_HOME_BANNERS_REQUEST",
    CAMPAIGN_HOME_BANNERS_COMPLETE: "CAMPAIGN_HOME_BANNERS_COMPLETE",

    CAMPAIGN_VOUCHER_ADDTO_FAVOURITE_REQUEST:
        "CAMPAIGN_VOUCHER_ADDTO_FAVOURITE_REQUEST",
    CAMPAIGN_VOUCHER_ADDTO_FAVOURITE_COMPLETE:
        "CAMPAIGN_VOUCHER_ADDTO_FAVOURITE_COMPLETE",

    CAMPAIGN_VOUCHER_REMOVEFROM_FAVOURITE_REQUEST:
        "CAMPAIGN_VOUCHER_REMOVEFROM_FAVOURITE_REQUEST",
    CAMPAIGN_VOUCHER_REMOVEFROM_FAVOURITE_COMPLETE:
        "CAMPAIGN_VOUCHER_REMOVEFROM_FAVOURITE_COMPLETE",

    GET_CAMPAIGN_LEAGUE_TABLE_REQUEST: "GET_CAMPAIGN_LEAGUE_TABLE_REQUEST",
    GET_CAMPAIGN_LEAGUE_TABLE_COMPLETE: "GET_CAMPAIGN_LEAGUE_TABLE_COMPLETE",

    GET_PARTICIPANT_SALES_REQUEST: "GET_PARTICIPANT_SALES_REQUEST",
    GET_PARTICIPANT_SALES_COMPLETE: "GET_PARTICIPANT_SALES_COMPLETE",

    GET_CAMPAIGN_PRIZEDRAW_DETAILS_REQUEST:
        "GET_CAMPAIGN_PRIZEDRAW_DETAILS_REQUEST",
    GET_CAMPAIGN_PRIZEDRAW_DETAILS_COMPLETE:
        "GET_CAMPAIGN_PRIZEDRAW_DETAILS_COMPLETE",

    ADD_PRIZE_DRAW_CAMPAIGN_ENTRY_DATA_REQUEST:
        "ADD_PRIZE_DRAW_CAMPAIGN_ENTRY_DATA_REQUEST",
    ADD_PRIZE_DRAW_CAMPAIGN_ENTRY_DATA_COMPLETE:
        "ADD_PRIZE_DRAW_CAMPAIGN_ENTRY_DATA_COMPLETE",

    GET_LEAGUE_INDIVIDUAL_DETAILS_DATA_REQUEST:
        "GET_LEAGUE_INDIVIDUAL_DETAILS_DATA_REQUEST",
    GET_LEAGUE_INDIVIDUAL_DETAILS_DATA_COMPLETE:
        "GET_LEAGUE_INDIVIDUAL_DETAILS_DATA_COMPLETE",

    GET_LEAGUE_TEAM_DETAILS_DATA_REQUEST:
        "GET_LEAGUE_TEAM_DETAILS_DATA_REQUEST",
    GET_LEAGUE_TEAM_DETAILS_DATA_COMPLETE:
        "GET_LEAGUE_TEAM_DETAILS_DATA_COMPLETE",

    SUBMIT_LEAGUE_TEAM_PARTICIPANT_REQUEST:
        "SUBMIT_LEAGUE_TEAM_PARTICIPANT_REQUEST",
    SUBMIT_LEAGUE_TEAM_PARTICIPANT_COMPLETE:
        "SUBMIT_LEAGUE_TEAM_PARTICIPANT_COMPLETE",

    GET_COMMS_DETAILS_REQUEST: "GET_COMMS_DETAILS_REQUEST",
    GET_COMMS_DETAILS_COMPLETE: "GET_COMMS_DETAILS_COMPLETE",

    CAMPAIGN_GET_WARE_AND_TIRE_SUMMARY_REQUEST:
        "CAMPAIGN_GET_WARE_AND_TIRE_SUMMARY_REQUEST",
    CAMPAIGN_GET_WARE_AND_TIRE_SUMMARY_COMPLETE:
        "CAMPAIGN_GET_WARE_AND_TIRE_SUMMARY_COMPLETE",

    CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_REQUEST:
        "CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_REQUEST",
    CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_COMPLETE:
        "CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_COMPLETE",

    CAMPAIGN_GET_PARTICIPANT_ACTIVE_CAMPAIGNS_REQUEST:
        "CAMPAIGN_GET_PARTICIPANT_ACTIVE_CAMPAIGNS_REQUEST",
    CAMPAIGN_GET_PARTICIPANT_ACTIVE_CAMPAIGNS_COMPLETE:
        "CAMPAIGN_GET_PARTICIPANT_ACTIVE_CAMPAIGNS_COMPLETE",

    CAMPAIGN_GET_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_REQUEST:
        "CAMPAIGN_GET_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_REQUEST",
    CAMPAIGN_GET_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_COMPLETE:
        "CAMPAIGN_GET_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_COMPLETE",

    CAMPAIGN_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_CLEAR:
        "CAMPAIGN_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_CLEAR",

    CAMPAIGN_PARTICIPANT_ACTIVE_CAMPAIGNS_CLEAR:
        "CAMPAIGN_PARTICIPANT_ACTIVE_CAMPAIGNS_CLEAR",

    CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_SUMMARY_REQUEST:
        "CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_SUMMARY_REQUEST",
    CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_SUMMARY_COMPLETE:
        "CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_SUMMARY_COMPLETE",

    CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_Q4_SUMMARY_REQUEST:
        "CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_Q4_SUMMARY_REQUEST",
    CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_Q4_SUMMARY_COMPLETE:
        "CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_Q4_SUMMARY_COMPLETE",

    CAMPAIGN_PAGE_LOG_PAGE_VIEW_REQUEST: "CAMPAIGN_PAGE_LOG_PAGE_VIEW_REQUEST",
    CAMPAIGN_PAGE_LOG_PAGE_VIEW_COMPLETE:
        "CAMPAIGN_PAGE_LOG_PAGE_VIEW_COMPLETE",

    CAMPAIGN_PAGE_LIKE_CONTENT_REQUEST: "CAMPAIGN_PAGE_LIKE_CONTENT_REQUEST",
    CAMPAIGN_PAGE_LIKE_CONTENT_COMPLETE: "CAMPAIGN_PAGE_LIKE_CONTENT_COMPLETE",

    CAMPAIGN_PAGE_LIKE_SUMMARY_REQUEST: "CAMPAIGN_PAGE_LIKE_SUMMARY_REQUEST",
    CAMPAIGN_PAGE_LIKE_SUMMARY_COMPLETE: "CAMPAIGN_PAGE_LIKE_SUMMARY_COMPLETE",

    CAMPAIGN_GET_AREA_MANAGERS_DEALERS_REQUEST:
        "CAMPAIGN_GET_AREA_MANAGERS_DEALERS_REQUEST",
    CAMPAIGN_GET_AREA_MANAGERS_DEALERS_COMPLETE:
        "CAMPAIGN_GET_AREA_MANAGERS_DEALERS_COMPLETE",
    CAMPAIGN_GET_OVERDRIVE_DEALERS_REQUEST:
        "CAMPAIGN_GET_OVERDRIVE_DEALERS_REQUEST",
    CAMPAIGN_GET_OVERDRIVE_DEALERS_COMPLETE:
        "CAMPAIGN_GET_OVERDRIVE_DEALERS_COMPLETE",

    CAMPAIGN_GET_PARTICIPANTS_BY_DEALERS_REQUEST:
        "CAMPAIGN_GET_PARTICIPANTS_BY_DEALERS_REQUEST",
    CAMPAIGN_GET_PARTICIPANTS_BY_DEALERS_COMPLETE:
        "CAMPAIGN_GET_PARTICIPANTS_BY_DEALERS_COMPLETE",

    CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_REQUEST:
        "CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_REQUEST",
    CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_COMPLETE:
        "CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_COMPLETE",

    CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_DROP_DOWN_REQUEST:
        "CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_DROP_DOWN_REQUEST",
    CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_DROP_DOWN_COMPLETE:
        "CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_DROP_DOWN_COMPLETE",

    CAMPAIGN_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_REQUEST:
        "CAMPAIGN_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_REQUEST",
    CAMPAIGN_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_COMPLETE:
        "CAMPAIGN_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_COMPLETE",

    CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_REQUEST:
        "CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_REQUEST",
    CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_COMPLETE:
        "CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_COMPLETE",

    CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_DROP_DOWN_REQUEST:
        "CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_DROP_DOWN_REQUEST",
    CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_DROP_DOWN_COMPLETE:
        "CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_DROP_DOWN_COMPLETE",

    CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_PADS_SUMMARY_REQUEST:
        "CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_PADS_SUMMARY_REQUEST",
    CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_PADS_SUMMARY_COMPLETE:
        "CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_PADS_SUMMARY_COMPLETE",

    CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_WIPER_BLADE_SUMMARY_REQUEST:
        "CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_WIPER_BLADE_SUMMARY_REQUEST",
    CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_WIPER_BLADE_SUMMARY_COMPLETE:
        "CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_WIPER_BLADE_SUMMARY_COMPLETE",

    CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_DISCS_SUMMARY_REQUEST:
        "CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_DISCS_SUMMARY_REQUEST",
    CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_DISCS_SUMMARY_COMPLETE:
        "CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_DISCS_SUMMARY_COMPLETE",

    CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_AREA_TOP_SUMMARY_REQUEST:
        "CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_AREA_TOP_SUMMARY_REQUEST",
    CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_AREA_TOP_SUMMARY_COMPLETE:
        "CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_AREA_TOP_SUMMARY_COMPLETE",

    CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_REQUEST:
        "CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_REQUEST",
    CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_COMPLETE:
        "CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_COMPLETE",

    GET_TLC_CUSTOMER_REQUEST: "GET_TLC_CUSTOMER_REQUEST",
    GET_TLC_CUSTOMER_COMPLETE: "GET_TLC_CUSTOMER_COMPLETE",

    GET_GOLD_RUSH_CAMPAIGN_PERFORMANCE_SUMMARY_REQUEST:
        "GET_GOLD_RUSH_CAMPAIGN_PERFORMANCE_SUMMARY_REQUEST",
    GET_GOLD_RUSH_CAMPAIGN_PERFORMANCE_SUMMARY_COMPLETE:
        "GET_GOLD_RUSH_CAMPAIGN_PERFORMANCE_SUMMARY_COMPLETE",

    GET_CASTROL_DEALER_PERFORMANCE_SUMMARY_REQUEST:
        "GET_CASTROL_DEALER_PERFORMANCE_SUMMARY_REQUEST",
    GET_CASTROL_DEALER_PERFORMANCE_SUMMARY_COMPLETE:
        "GET_CASTROL_DEALER_PERFORMANCE_SUMMARY_COMPLETE",

    CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_DROP_DOWN_REQUEST:
        "CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_DROP_DOWN_REQUEST",
    CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_DROP_DOWN_COMPLETE:
        "CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_DROP_DOWN_COMPLETE",

    CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_DROP_DOWN_REQUEST:
        "CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_DROP_DOWN_REQUEST",

    CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_DROP_DOWN_COMPLETE:
        "CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_DROP_DOWN_COMPLETE",

    TLC_GET_TLC_RETAILERS_REQUEST: "TLC_GET_TLC_RETAILERS_REQUEST",
    TLC_GET_TLC_RETAILERS_COMPLETE: "TLC_GET_TLC_RETAILERS_COMPLETE",

    CAMPAIGN_GET_WEAR_AND_TEAR_TEAM_PERFORMANCE_SUMMARY_REQUEST:
        "CAMPAIGN_GET_WEAR_AND_TEAR_TEAM_PERFORMANCE_SUMMARY_REQUEST",
    CAMPAIGN_GET_WEAR_AND_TEAR_TEAM_PERFORMANCE_SUMMARY_COMPLETE:
        "CAMPAIGN_GET_WEAR_AND_TEAR_TEAM_PERFORMANCE_SUMMARY_COMPLETE",

    CAMPAIGN_SERVICE_STAR_GET_SERVICE_STAR_LEAGUE_RANK_SUMMARY_REQUEST:
        "CAMPAIGN_SERVICE_STAR_GET_SERVICE_STAR_LEAGUE_RANK_SUMMARY_REQUEST",

    CAMPAIGN_SERVICE_STAR_GET_SERVICE_STAR_LEAGUE_RANK_SUMMARY_COMPLETE:
        "CAMPAIGN_SERVICE_STAR_GET_SERVICE_STAR_LEAGUE_RANK_SUMMARY_COMPLETE",

    CAMPAIGN_GET_WINNING_SPIN_DATA_REQUEST:
        "CAMPAIGN_GET_WINNING_SPIN_DATA_REQUEST",

    CAMPAIGN_GET_WINNING_SPIN_DATA_COMPLETE:
        "CAMPAIGN_GET_WINNING_SPIN_DATA_COMPLETE",

    CAMPAIGN_GET_LCV_REGISTRATION_TRACKER_REQUEST:
        "CAMPAIGN_GET_LCV_REGISTRATION_TRACKER_REQUEST",
    CAMPAIGN_GET_LCV_REGISTRATION_TRACKER_COMPLETE:
        "CAMPAIGN_GET_LCV_REGISTRATION_TRACKER_COMPLETE",
    CAMPAIGN_GET_LCV_WINNING_SPINS_REQUEST:
        "CAMPAIGN_GET_LCV_WINNING_SPINS_REQUEST",
    CAMPAIGN_GET_LCV_WINNING_SPINS_COMPLETE:
        "CAMPAIGN_GET_LCV_WINNING_SPINS_COMPLETE",
    CAMPAIGN_GET_LCV_WINNING_SPINS_ERROR:
        "CAMPAIGN_GET_LCV_WINNING_SPINS_ERROR",

    CAMPAIGN_GET_ALPINE_REWARD_SUMMARY_REQUEST:
        "CAMPAIGN_GET_ALPINE_REWARD_SUMMARY_REQUEST",
    CAMPAIGN_GET_ALPINE_REWARD_SUMMARY_COMPLETE:
        "CAMPAIGN_GET_ALPINE_REWARD_SUMMARY_COMPLETE",

    CAMPAIGN_GET_TRADE_PARTS_MANAGER_INCENTIVE_REQUEST:
        "CAMPAIGN_GET_TRADE_PARTS_MANAGER_INCENTIVE_REQUEST",
    CAMPAIGN_GET_TRADE_PARTS_MANAGER_INCENTIVE_COMPLETE:
        "CAMPAIGN_GET_TRADE_PARTS_MANAGER_INCENTIVE_COMPLETE",

    CAMPAIGN_GET_CASTROL_MOTO_GP_LEAGUES_RANK_SUMMARY_REQUEST:
        "CAMPAIGN_GET_CASTROL_MOTO_GP_LEAGUES_RANK_SUMMARY_REQUEST",
    CAMPAIGN_GET_CASTROL_MOTO_GP_LEAGUES_RANK_SUMMARY_COMPLETE:
        "CAMPAIGN_GET_CASTROL_MOTO_GP_LEAGUES_RANK_SUMMARY_COMPLETE",

    CAMPAIGN_GET_TLC_CUSTOMER_BY_DEALERS_REQUEST:
        "CAMPAIGN_GET_TLC_CUSTOMER_BY_DEALERS_REQUEST",
    CAMPAIGN_GET_TLC_CUSTOMER_BY_DEALERS_COMPLETE:
        "CAMPAIGN_GET_TLC_CUSTOMER_BY_DEALERS_COMPLETE",

    CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_SUMMARY_REQUEST:
        "CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_SUMMARY_REQUEST",
    CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_SUMMARY_COMPLETE:
        "CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_SUMMARY_COMPLETE",

    CAMPAIGN_GOLDEN_TICKET_SCRATCH_CARD_DATA_REQUEST:
        "CAMPAIGN_GOLDEN_TICKET_SCRATCH_CARD_DATA_REQUEST",
    CAMPAIGN_GOLDEN_TICKET_SCRATCH_CARD_DATA_COMPLETE:
        "CAMPAIGN_GOLDEN_TICKET_SCRATCH_CARD_DATA_COMPLETE",

    CAMPAIGN_GOLDEN_TICKET_CLAIM_SCRATCH_CARD_CODE_REQUEST:
        "CAMPAIGN_GOLDEN_TICKET_CLAIM_SCRATCH_CARD_CODE_REQUEST",
    CAMPAIGN_GOLDEN_TICKET_CLAIM_SCRATCH_CARD_CODE_COMPLETE:
        "CAMPAIGN_GOLDEN_TICKET_CLAIM_SCRATCH_CARD_CODE_COMPLETE",

    CAMPAIGN_VOTE_REWARD_PREFERENCES_REQUEST:
        "CAMPAIGN_VOTE_REWARD_PREFERENCES_REQUEST",
    CAMPAIGN_VOTE_REWARD_PREFERENCES_COMPLETE:
        "CAMPAIGN_VOTE_REWARD_PREFERENCES_COMPLETE",

    CAMPAIGN_CHANGE_ROLE: "CAMPAIGN_CHANGE_ROLE",
    CAMPAIGN_GET_ALL_AREA_MANAGERS_DEALERS_REQUEST:
        "CAMPAIGN_GET_ALL_AREA_MANAGERS_DEALERS_REQUEST",
    CAMPAIGN_GET_ALL_AREA_MANAGERS_DEALERS_COMPLETE:
        "CAMPAIGN_GET_ALL_AREA_MANAGERS_DEALERS_COMPLETE",

    CAMPAIGN_GET_CASTROL500_CAMPAIGN_REQUEST:
        "CAMPAIGN_GET_CASTROL500_CAMPAIGN_REQUEST",
    CAMPAIGN_GET_CASTROL500_CAMPAIGN_COMPLETE:
        "CAMPAIGN_GET_CASTROL500_CAMPAIGN_COMPLETE",

    CAMPAIGN_GET_EARN_BIG_BRAKE_CAMPAIGN_REQUEST:
        "CAMPAIGN_GET_EARN_BIG_BRAKE_CAMPAIGN_REQUEST",
    CAMPAIGN_GET_EARN_BIG_BRAKE_CAMPAIGN_COMPLETE:
        "CAMPAIGN_GET_EARN_BIG_BRAKE_CAMPAIGN_COMPLETE",

    CAMPAIGN_GET_CUTTING_EDGE_Q3_CAMPAIGN_DATA_REQUEST:
        "CAMPAIGN_GET_CUTTING_EDGE_Q3_CAMPAIGN_DATA_REQUEST",
    CAMPAIGN_GET_CUTTING_EDGE_Q3_CAMPAIGN_DATA_COMPLETE:
        "CAMPAIGN_GET_CUTTING_EDGE_Q3_CAMPAIGN_DATA_COMPLETE",

    CAMPAIGN_GET_CUTTING_EDGE_Q4_CAMPAIGN_DATA_REQUEST:
        "CAMPAIGN_GET_CUTTING_EDGE_Q4_CAMPAIGN_DATA_REQUEST",
    CAMPAIGN_GET_CUTTING_EDGE_Q4_CAMPAIGN_DATA_COMPLETE:
        "CAMPAIGN_GET_CUTTING_EDGE_Q4_CAMPAIGN_DATA_COMPLETE",

    CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_Q3_SUMMARY_REQUEST:
        "CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_Q3_SUMMARY_REQUEST",
    CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_Q3_SUMMARY_COMPLETE:
        "CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_Q3_SUMMARY_COMPLETE",

    CAMPAIGN_GET_DEALER_EHCV_FOCUS_CAMPAIGN_DATA_REQUEST:
        "CAMPAIGN_GET_DEALER_EHCV_FOCUS_CAMPAIGN_DATA_REQUEST",
    CAMPAIGN_GET_DEALER_EHCV_FOCUS_CAMPAIGN_DATA_COMPLETE:
        "CAMPAIGN_GET_DEALER_EHCV_FOCUS_CAMPAIGN_DATA_COMPLETE",

    CAMPAIGN_GET_SERVICE_STAR_2026_CAMPAIGN_DATA_REQUEST:
        "CAMPAIGN_GET_SERVICE_STAR_2026_CAMPAIGN_DATA_REQUEST",
    CAMPAIGN_GET_SERVICE_STAR_2026_CAMPAIGN_DATA_COMPLETE:
        "CAMPAIGN_GET_SERVICE_STAR_2026_CAMPAIGN_DATA_COMPLETE",

    CAMPAIGN_GET_ICRM_CAMPAIGN_DATA_REQUEST:
        "CAMPAIGN_GET_ICRM_CAMPAIGN_DATA_REQUEST",
    CAMPAIGN_GET_ICRM_CAMPAIGN_DATA_COMPLETE:
        "CAMPAIGN_GET_ICRM_CAMPAIGN_DATA_COMPLETE",

    CAMPAIGN_GET_CUTTING_EDGE_CAMPAIGN_DATA_REQUEST:
        "CAMPAIGN_GET_CUTTING_EDGE_CAMPAIGN_DATA_REQUEST",
    CAMPAIGN_GET_CUTTING_EDGE_CAMPAIGN_DATA_COMPLETE:
        "CAMPAIGN_GET_CUTTING_EDGE_CAMPAIGN_DATA_COMPLETE",

    CAMPAIGN_SEARCH_CUSTOMERS_REQUEST: "CAMPAIGN_SEARCH_CUSTOMERS_REQUEST",
    CAMPAIGN_SEARCH_CUSTOMERS_COMPLETE: "CAMPAIGN_SEARCH_CUSTOMERS_COMPLETE",

    CAMPAIGN_GET_MOTRIO_TRADE_TARGETS_REQUEST: "CAMPAIGN_GET_MOTRIO_TRADE_TARGETS_REQUEST",
    CAMPAIGN_GET_MOTRIO_TRADE_TARGETS_COMPLETE: "CAMPAIGN_GET_MOTRIO_TRADE_TARGETS_COMPLETE",

    CAMPAIGN_GET_CUSTOMER_ACCOUNT_STATUS_REQUEST: "CAMPAIGN_GET_CUSTOMER_ACCOUNT_STATUS_REQUEST",
    CAMPAIGN_GET_CUSTOMER_ACCOUNT_STATUS_COMPLETE: "CAMPAIGN_GET_CUSTOMER_ACCOUNT_STATUS_COMPLETE",

    CAMPAIGN_GET_RG_REWARDS_TARGETS_REQUEST: "CAMPAIGN_GET_RG_REWARDS_TARGETS_REQUEST",
    CAMPAIGN_GET_RG_REWARDS_TARGETS_COMPLETE: "CAMPAIGN_GET_RG_REWARDS_TARGETS_COMPLETE",

    CAMPAIGN_GET_RG_REWARDS_TARGETS_BY_CUSTOMER_REQUEST: "CAMPAIGN_GET_RG_REWARDS_TARGETS_BY_CUSTOMER_REQUEST",
    CAMPAIGN_GET_RG_REWARDS_TARGETS_BY_CUSTOMER_COMPLETE: "CAMPAIGN_GET_RG_REWARDS_TARGETS_BY_CUSTOMER_COMPLETE",

    CAMPAIGN_SEND_ACTIVATION_EMAIL_REQUEST: "CAMPAIGN_SEND_ACTIVATION_EMAIL_REQUEST",
    CAMPAIGN_SEND_ACTIVATION_EMAIL_COMPLETE: "CAMPAIGN_SEND_ACTIVATION_EMAIL_COMPLETE",

    CAMPAIGN_GET_MOTRIO_REWARDS_BY_CUSTOMER_REQUEST: "CAMPAIGN_GET_MOTRIO_REWARDS_BY_CUSTOMER_REQUEST",
    CAMPAIGN_GET_MOTRIO_REWARDS_BY_CUSTOMER_COMPLETE: "CAMPAIGN_GET_MOTRIO_REWARDS_BY_CUSTOMER_COMPLETE",

    CAMPAIGN_GET_MOTRIO_PAYDAYS_WINNERS_REQUEST:
        "CAMPAIGN_GET_MOTRIO_PAYDAYS_WINNERS_REQUEST",
    CAMPAIGN_GET_MOTRIO_PAYDAYS_WINNERS_COMPLETE:
        "CAMPAIGN_GET_MOTRIO_PAYDAYS_WINNERS_COMPLETE",

    CAMPAIGN_GET_CASTROL_LEGENDS_CAMPAIGN_DATA_REQUEST: "CAMPAIGN_GET_CASTROL_LEGENDS_CAMPAIGN_DATA_REQUEST",
    CAMPAIGN_GET_CASTROL_LEGENDS_CAMPAIGN_DATA_COMPLETE: "CAMPAIGN_GET_CASTROL_LEGENDS_CAMPAIGN_DATA_COMPLETE",

    CAMPAIGN_GET_CASTROL_LEGENDS_CAMPAIGN_PERFORMANCE_DATA_REQUEST: "CAMPAIGN_GET_CASTROL_LEGENDS_CAMPAIGN_PERFORMANCE_DATA_REQUEST",
    CAMPAIGN_GET_CASTROL_LEGENDS_CAMPAIGN_PERFORMANCE_DATA_COMPLETE: "CAMPAIGN_GET_CASTROL_LEGENDS_CAMPAIGN_PERFORMANCE_DATA_COMPLETE",

    CAMPAIGN_GET_LIQUID_GOLD_CAMPAIGN_INFO_REQUEST:
        "CAMPAIGN_GET_LIQUID_GOLD_CAMPAIGN_INFO_REQUEST",
    CAMPAIGN_GET_LIQUID_GOLD_CAMPAIGN_INFO_COMPLETE:
        "CAMPAIGN_GET_LIQUID_GOLD_CAMPAIGN_INFO_COMPLETE",

    CAMPAIGN_CLAIM_LIQUID_GOLD_SCRATCH_CODE_REQUEST:
        "CAMPAIGN_CLAIM_LIQUID_GOLD_SCRATCH_CODE_REQUEST",
    CAMPAIGN_CLAIM_LIQUID_GOLD_SCRATCH_CODE_COMPLETE:
        "CAMPAIGN_CLAIM_LIQUID_GOLD_SCRATCH_CODE_COMPLETE",

    CAMPAIGN_GET_OPTIMUM_FRICTION_CAMPAIGN_INFO_REQUEST:
        "CAMPAIGN_GET_OPTIMUM_FRICTION_CAMPAIGN_INFO_REQUEST",
    CAMPAIGN_GET_OPTIMUM_FRICTION_CAMPAIGN_INFO_COMPLETE:
        "CAMPAIGN_GET_OPTIMUM_FRICTION_CAMPAIGN_INFO_COMPLETE",

    CAMPAIGN_GET_OPTIMUM_FRICTION_CARDS_REQUEST:
        "CAMPAIGN_GET_OPTIMUM_FRICTION_CARDS_REQUEST",
    CAMPAIGN_GET_OPTIMUM_FRICTION_CARDS_COMPLETE:
        "CAMPAIGN_GET_OPTIMUM_FRICTION_CARDS_COMPLETE",

    CAMPAIGN_GET_OPTIMUM_FRICTION_WINNERS_REQUEST:
        "CAMPAIGN_GET_OPTIMUM_FRICTION_WINNERS_REQUEST",
    CAMPAIGN_GET_OPTIMUM_FRICTION_WINNERS_COMPLETE:
        "CAMPAIGN_GET_OPTIMUM_FRICTION_WINNERS_COMPLETE",

    CAMPAIGN_PLAY_OPTIMUM_FRICTION_CARD_REQUEST:
        "CAMPAIGN_PLAY_OPTIMUM_FRICTION_CARD_REQUEST",
    CAMPAIGN_PLAY_OPTIMUM_FRICTION_CARD_COMPLETE:
        "CAMPAIGN_PLAY_OPTIMUM_FRICTION_CARD_COMPLETE",
    CAMPAIGN_PLAY_OPTIMUM_FRICTION_CARD_ERROR:
        "CAMPAIGN_PLAY_OPTIMUM_FRICTION_CARD_ERROR",
    CAMPAIGN_PLAY_OPTIMUM_FRICTION_CARD_RESET:
        "CAMPAIGN_PLAY_OPTIMUM_FRICTION_CARD_RESET",
    CAMPAIGN_GET_OVER_DRIVEN_CAMPAIGN_DATA_REQUEST:
        "CAMPAIGN_GET_OVER_DRIVEN_CAMPAIGN_DATA_REQUEST",
    CAMPAIGN_GET_OVER_DRIVEN_CAMPAIGN_DATA_COMPLETE:
        "CAMPAIGN_GET_OVER_DRIVEN_CAMPAIGN_DATA_COMPLETE",
};

export const voucherTypes = {
    DEAL_VOUCHER: 1,
    TRENDING_VOUCHER: 2,
};

export const campaignTypes = {
    CAMPAIGN_TYPE_LEAGUE_INDIVIDUAL: 1,
    CAMPAIGN_TYPE_HIT_AND_WIN: 2,
    CAMPAIGN_TYPE_BANDED: 3,
    CAMPAIGN_TYPE_PRIZE_DRAW: 4,
    CAMPAIGN_TYPE_LEAGUE_TEAM: 5,
    CAMPAIGN_TYPE_DIRECT_WIN: 6,
};

export const campaignTransactionTypes = {
    CAMPAIGN_EARN: 1,
    CAMPAIGN_SPEND: 2,
    CAMPAIGN_INSPIRE: 3,
};

export const campaignStatuses = {
    CAMPAIGN_STATUS_IS_ACTIVE: "1",
    CAMPAIGN_STATUS_CLOSED: "2",
    CAMPAIGN_STATUS_COMING_SOON: "3",
    CAMPAIGN_STATUS_OTHER: "0",
};

export const cardTypes = {
    CAMPAIGN: "CAMPAIGN",
    VOUCHER: "VOUCHER",
};

export const LCV_SALES_TEAM_CAMPAIGN_ID = 410;
export const LCV_SLEIGH_CAMPAIGN_ID = 413;
